/**
 * KnowledgebaseMoveDirection
 */
export enum KnowledgebaseMoveDirection {
    DOWN = 'down',
    UP = 'up'
}
